const config = {
  appId: "wx771820531f2d9634", //问卷加加
  name: "问卷加加",
  mainTitle: "问卷加加-小程序问卷调研制作平台,考试评测,市场调研免费制作",
  title: "问卷加加",
  logo: "https://ossfastmake.mustke.com/qrCode/tupian/1755832594677.png",
  companyName: "哈尔滨快智科技有限公司",
  filing: "黑ICP备19003235号-83",
  logoTitle: require("@/assets/images/config/wjjj_title.svg"),
  loginLogo: require("@/assets/images/config/login_logo_jj.png"),
  miniProgramCode: require("@/assets/images/config/miniProgramCode1.jpg"),
  kefuCode: require("@/assets/images/config/kefuCode1.png"),
  bannerImage: require("@/assets/images/config/bannerImage1.png"),
  openClawImage: require("@/assets/images/config/openClawBanner1.png"),
  subscriptions: require("@/assets/images/config/subscriptions1.png"),
  // 添加favicon配置
  favicon: {
    // 默认favicon
    default: "https://ossfastmake.mustke.com/qrCode/tupian/1755832594677.png",
    // 可以根据需要添加更多favicon配置
    alternative:
      "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
  },
  skillInstruction:
    "https://skill.youzhiapp.com/api/skills/download/389c723a-53ec-4937-ae77-9af8ed16779c?key=XL52k7rZF9UJUTpJukNdsRfT", // 问卷加加指令下载地址
  skillDownloadUrl: "https://skill.youzhiapp.com/download/wenjuanjiajia.zip", // 问卷加加直接下载地址
  keywords:
    "问卷加加，在线问卷，考试系统，AI生成题目，免费制作问卷，成绩分析，数据统计",
  description:
    "问卷加加是一站式在线调研与考试评测平台。支持免费制作问卷、市场调研及考试。内置AI智能助手，可一键生成文案、封面与考题，并提供成绩统计与数据分析。",
};

// const config = {
//   appId: "wx970228cfffbc37d2", //问卷管家
//   name: "问卷管家",
//   mainTitle: "问卷管家|问卷调研小程序制作平台,考试测评,考题调查快速发起",
//   title: "问卷管家",
//   logo: "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//   companyName: "哈尔滨优智科技有限公司",
//   filing: "黑ICP备13000410号-113",
//   logoTitle: require("@/assets/images/config/wjgj_title.svg"),
//   loginLogo: require("@/assets/images/config/login_logo_gj.png"),
//   miniProgramCode: require("@/assets/images/config/miniProgramCode2.jpg"),
//   kefuCode: require("@/assets/images/config/kefuCode2.png"),
//   bannerImage: require("@/assets/images/config/bannerImage2.png"),
//   openClawImage: require("@/assets/images/config/openClawBanner2.svg"),
//   subscriptions: require("@/assets/images/config/subscriptions2.jpg"),
//   // 添加favicon配置
//   favicon: {
//     // 默认favicon
//     default: "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//     // 可以根据需要添加更多favicon配置
//     alternative:
//       "https://ossfastmake.mustke.com/qrCode/tupian/1755832528655.svg",
//   },
//   skillInstruction:
//     "https://skill.youzhiapp.com/api/skills/download/7bbbecc5-cc46-4e03-811d-7b6130d70be7?key=XL52k7rZF9UJUTpJukNdsRfT", // 问卷管家指令下载地址
//   skillDownloadUrl: "https://skill.youzhiapp.com/download/wenjuanguanjia.zip", // 问卷管家直接下载地址
//   keywords:
//     "问卷制作，在线问卷，免费问卷，考试系统，测评工具，市场调研，答题统计，红包问卷，问卷分发",
//   description:
//     "问卷管家提供免费的在线问卷制作服务，支持市场调研、员工测评、学生考试、活动报名等多种场景，一键生成问卷、数据统计，还支持短信 / 邮件 / 公众号分发，高效收集反馈。",
// };

export default config;



// WEBPACK FOOTER //
// ./src/utils/config.js